import Text from "./shared/Text";

/**
 * FeaturePillMarquee — horizontal scrolling band of feature labels with
 * 4-point sparkle separators, set on a pink → peach horizontal gradient
 * band. Used on the pricing page as a decorative ticker between the
 * hero and the plans compare section.
 */

export type FeaturePillMarqueeProps = {
  items: string[];
  /** Optional tailwind class override for the band background. When
   *  omitted, defaults to the pink→peach gradient. */
  bgClassName?: string;
};

const Sparkle = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    className="h-4 w-4 shrink-0 text-neutralBlack md:h-[18px] md:w-[18px]"
    fill="currentColor"
  >
    <path d="M12 0 L13.6 10.4 L24 12 L13.6 13.6 L12 24 L10.4 13.6 L0 12 L10.4 10.4 Z" />
  </svg>
);

const FeaturePillMarquee = ({
  items,
  bgClassName,
}: FeaturePillMarqueeProps) => {
  // Duplicate the list so the horizontal scroll loops seamlessly.
  const loop = [...items, ...items, ...items];
  return (
    <section
      className={`relative w-full overflow-hidden ${
        bgClassName ??
        "bg-[linear-gradient(90deg,#F5D4E4_0%,#F6D7DE_40%,#FADFD2_70%,#FCE6C8_100%)]"
      }`}
      aria-hidden="true"
    >
      <div className="flex w-max gap-8 whitespace-nowrap py-4 animate-[feature-marquee-left_40s_linear_infinite] md:gap-10 md:py-5">
        {loop.map((item, idx) => (
          <div key={`${item}-${idx}`} className="flex items-center gap-8 md:gap-10">
            <Text
              as="span"
              variant="label"
              className="text-[13px] font-semibold uppercase tracking-[0.12em] text-neutralBlack md:text-[14px]"
            >
              {item}
            </Text>
            <Sparkle />
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturePillMarquee;
